import axios from "axios";
import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import dollor from "../../assets/icons/dollar.svg";
import percentage from "../../assets/icons/percentage.svg";
import useAuth from "../../hooks/useAuth";
import { BASE_URL } from "../../utils/Element";
import InputWithIcon from "../InputWithIcon";
import Modal from "../Modal/Modal";

const initialData = {
  lead_type: "",
  lead_status: "",
  suggested_sale_price: "",
  suggested_cap_price: ""
};



const ConfirmationModalBov = ({ showModal, onClose, handleUnderContract, id, onCallApi , pipelineDetails, }) => {
  const [formData, setFormData] = useState(initialData);
  const [config] = useAuth()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState();
  const statusOptions = [
    { value: 2, label: "Cold" },
    { value: 3, label: "Warm" },
    { value: 1, label: "Hot" },
  ];

  const handleClose = () => {
  setFormData(initialData); 
  setError({});             
  onClose();
};


  const handleChange = (value, name) => {
    setError({ ...error, [name]: "" });
    setFormData({ ...formData, [name]: value });
  };

   useEffect(() => {
    if (pipelineDetails?.LeadsList && showModal) {
      const leadData = pipelineDetails.LeadsList

      setFormData({
        suggested_sale_price: leadData.lead?.property?.asking_price_format,
        suggested_cap_price: leadData.lead?.property?.asking_cap_rate_format,
      })
    }
  }, [pipelineDetails, showModal])

  const handleConvertBov = () => {
    const dataToSend = {
      lead_status: formData.lead_status,
      suggested_sale_price: formData.suggested_sale_price,
      suggested_cap_price: formData.suggested_cap_price,
    };

    axios
      .post(`${BASE_URL}/bov-convert/${id}`, dataToSend, config) // Changed to POST
      .then((res) => {
        onCallApi();
        onClose();
        if (res?.data?.message) {
          NotificationManager.success(res?.data?.message);
        }
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      })
      .finally(() => setLoading(false));
  };




  return (
    <Modal width="450px" title={"Convert to BOV"} desc={`Add BOV information`} show={showModal} onClose={handleClose}>
      <form className="py-3 ">
        {/* <div className="flex-1 w-30 mb-2">
          <p className="head-1 dark-H font-bold">Convert to BOV</p>
          <p className="py-1 dark-M body-L">Add BOV information</p>
         </div> */}

        <div className="mt-1.5">
          <label className="dark-H head-4 mb-2 required:*:">
            Status<span className="red-D">*</span>
          </label>
          <div>
            <Select
              options={statusOptions}
              value={statusOptions.find((option) => option.value === formData.lead_status) || null}
              onChange={(option) => {
                setError({ ...error, lead_status: "" });
                handleChange(option.value, "lead_status");
              }}
              placeholder="Select Status"
              className="body-N"
            />
          </div>

        </div>

        <div className="mt-1.5">
          <label className="dark-H head-4 mb-2">Suggested Sale Price</label>
          <InputWithIcon
            icon={dollor}
            className="body-N"
            name="suggested_sale_price"
            type="number"
            placeholder="Write Suggested Sale Price"
            value={formData.suggested_sale_price ?? ""}
            onChange={(e) => handleChange(e.target.value, "suggested_sale_price")}
          />
          {error?.suggested_sale_price && <p className="body-S red-D pt-1">{error?.suggested_sale_price}</p>}
        </div>

        <div className="mt-1.5">
          <label className="dark-H head-4 mb-2">Suggested Cap Rate</label>
          <InputWithIcon
            icon={percentage}
            className="body-N"
            name="suggested_cap_price"
            type="number"
            placeholder="Write Suggested Cap Rate"
            value={formData.suggested_cap_price ?? ""}
            onChange={(e) => handleChange(e.target.value, "suggested_cap_price")}
          />
          {error?.suggested_cap_price && <p className="body-S red-D pt-1">{error?.suggested_cap_price}</p>}
        </div>


        <div className="mt-6 flex justify-start ">
          <button
            type="button"
            onClick={handleConvertBov}
            className="save-button light-L head-5 green-bg-H px-[30px] py-[12px]"
          >
            Save
          </button>

          <button type="button" onClick={handleClose}className="green-H body-N ml-5">
            Cancel
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default ConfirmationModalBov;
